import { cn } from '@/shadcn-ui/utils';

interface FilterOptionCheckboxContainerProps {
  children: React.ReactNode;
  className?: string;
}

export default function FilterOptionCheckboxContainer({
  children,
  className,
}: FilterOptionCheckboxContainerProps) {
  return <div className={cn('flex flex-col gap-[16px]', className)}>{children}</div>;
}
